// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HRuh","right":"styles_right__21WRd"};